import { render, staticRenderFns } from "./SearchCustomerSeller.vue?vue&type=template&id=4596493c&"
import script from "./SearchCustomerSeller.vue?vue&type=script&lang=js&"
export * from "./SearchCustomerSeller.vue?vue&type=script&lang=js&"
import style0 from "./SearchCustomerSeller.vue?vue&type=style&index=0&id=4596493c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports